import { Component, OnInit } from '@angular/core';
import { SeoService } from '../seo.service';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
    constructor(private seo: SeoService) {}

    ngOnInit() {
        this.seo.setTitle(`Page Not Found - NitroPay Sponsor`);
    }
}
